import {
  faArrowRight,
  faArrowLeft,
  faArrowsLeftRight,
  faArrowRightFromBracket as fasArrowRightFromBracket,
  faRightToBracket,
  faBriefcase as fasBriefcase,
  faCamera,
  faCameraRotate,
  faCheck,
  faChevronDown,
  faChevronUp,
  faChevronLeft,
  faChevronRight,
  faEuroSign,
  faGrid2 as fasGrid2,
  faSpinnerThird,
  faSpinner as fasSpinner,
  faObjectsColumn,
  faDiagramCells,
  faPlus,
  faTimer,
  faXmark,
  faCircleSmall,
  faCircleInfo,
  faExclamation,
  faPercent as faSolidPercent,
  faPhone as fasPhone,
  faPhoneArrowDownLeft as fasPhoneArrowDownLeft,
  faHeart,
  faAddressCard,
  faUpload,
  faDownload,
  faBuilding as fasBuilding,
  faFlag,
  faForward,
  faStar,
  faFileArrowDown,
  faInfinity,
  faHouse as fasHouse,
  faBell as fasBell,
  faUser as fasUser,
  faGauge as fasGauge,
  faHourglass,
  faFileCheck as fasFileCheck,
  faRotateLeft,
  faHouseCircleCheck as fasHouseCircleCheck,
  faFile as fasFile,
  faFilePdf as fasFilePdf,
  faMagnifyingGlass as fasMagnifyingGlass,
  faCircleCheck,
  faCircleXmark,
  faPaperclip,
  faArrowUp,
  faArrowDown,
  faArrowUpArrowDown,
  faUserGroupCrown,
  faInfo,
  faEnvelope as fasEnvelope,
  faTriangle,
  faBuildings as fasBuildings,
  faEye as fasEye,
  faBadgeCheck as fasBadgeCheck,
  faRefresh,
  faTrashCan as fasTrashCan,
  faCopy,
  faCirclePlay,
  faPencil as fasPencil,
  faGavel as fasGavel,
  faTrash,
  faListTree as fasListTree,
  faPenFancy as fasPenFancy,
  faListCheck as fasListCheck,
  faUsers as fasUsers,
  faIdCard as fasIdCard,
  faHouseBuilding as fasHouseBuilding,
  faCoins as fasCoins,
  faPercent as fasPercent,
  faGear,
  faEuroSign as fasEuroSign,
  faFiles as fasFiles,
  faChartMixed as fasChartMixed,
  faChartLineUp as fasChartLineUp,
  faHandHoldingDollar as fasHandHoldingDollar,
  faDisplayChartUp as fasDisplayChartUp,
  faArrowUpFromSquare,
} from '@fortawesome/pro-solid-svg-icons';

import {
  faBell,
  faBuilding,
  faBuildings,
  faCalendar,
  faCalendarClock,
  faClock,
  faEllipsis,
  faEye,
  faEyeSlash,
  faFarm,
  faHouse,
  faHouseBuilding,
  faHouseChimneyBlank,
  faHouseTree,
  faListCheck,
  faLocationDot,
  faPencil,
  faPhone,
  faRocket,
  faScrewdriverWrench,
  faStore,
  faShop,
  faTrashCan,
  faUser,
  faUsers,
  faCoins,
  faPercent,
  faFilePdf,
  faGrid2 as fadGrid2,
  faFileExcel,
  faMagnifyingGlass,
  faFile,
  faMugHot,
  faMugTea,
  faCupTogo,
  faWhiskeyGlass,
  faImageSlash,
  faIslandTropical,
  faCompass,
  faTrowelBricks,
  faStar as fadStar,
  faBars,
  faStarHalf,
  faSpinnerThird as fadSpinnerThird,
  faScaleUnbalanced,
  faCalendars,
  faHouseCircleExclamation,
  faBriefcase,
  faHouseCircleCheck,
  faSack,
  faLoader,
  faEnvelopes,
  faChartMixed,
  faHandshake,
  faHandHoldingDollar,
  faChevronDown as fadChevronDown,
  faUserTie,
  faClockRotateLeft,
  faCalendarDays,
  faFileCircleInfo,
  faSpinner,
  faCircleQuarter,
  faFiles,
  faMessageSlash,
  faHashtag,
  faArrowLeft as fadArrowLeft,
  faShopSlash,
  faBadgeCheck,
  faCircleXmark as fadCircleXmark,
  faListRadio as fadListRadio,
  faAddressBook as fadAddressBook,
  faFileLines as fadFileLines,
  faFileCirclePlus,
  faRabbitRunning,
  faShieldCheck,
  faShareAll,
  faMobileNotch,
  faRectangleHistoryCircleUser,
  faComments,
  faIdCard,
  faListTree,
  faComment,
  faPenFancy,
  faXmark as fadXmark,
  faFaceViewfinder,
  faBadgePercent,
  faReceipt,
  faPercentage,
  faCalendarWeek,
  faCheck as fadCheck,
  faEuroSign as fadEuroSign,
  faWallet,
} from '@fortawesome/pro-duotone-svg-icons';

import {
  faBriefcase as falBriefcase,
  faFile as falFile,
  faFaceSmileWink,
  faGrid2 as falGrid2,
  faArrowRightFromBracket as falArrowRightFromBracket,
  faPhoneArrowDownLeft as falPhoneArrowDownLeft,
  faHouse as falHouse,
  faBell as falBell,
  faUser as falUser,
  faGauge,
  faGavel,
  faFileCheck as falFileCheck,
  faHouseCircleCheck as falHouseCircleCheck,
  faAddressCard as falAddressCard,
  faUserGroupCrown as falUserGroupCrown,
  faPlay as falPlay,
  faPercentage as falPercentage,
  faFaceViewfinder as falFaceViewfinder,
  faDeleteLeft,
  faXmark as falXmark,
  faGear as falGear,
  faEuroSign as falEuroSign,
  faFingerprint,
  faFiles as falFiles,
  faChartMixed as falChartMixed,
  faChartLineUp as falChartLineUp,
  faHandHoldingDollar as falHandHoldingDollar,
  faDisplayChartUp as falDisplayChartUp,
  faCog as falCog,
} from '@fortawesome/pro-light-svg-icons';
import type { IconDefinition, IconPack } from "@fortawesome/fontawesome-common-types";

export const fontAwesomeIcons: (IconDefinition | IconPack)[] = [
  faArrowsLeftRight,
  fasArrowRightFromBracket,
  falArrowRightFromBracket,
  faRightToBracket,
  faBell,
  fasBriefcase,
  falBriefcase,
  falFile,
  faBuilding,
  faAddressCard,
  faBuildings,
  faCalendar,
  faCalendarClock,
  faClock,
  faCheck,
  faChevronDown,
  fadChevronDown,
  faChevronUp,
  faChevronLeft,
  faChevronRight,
  faEllipsis,
  faEuroSign,
  faEye,
  faEyeSlash,
  faFaceSmileWink,
  faFarm,
  faHeart,
  faHouse,
  faHouseBuilding,
  faHouseChimneyBlank,
  faHouseTree,
  faListCheck,
  faLocationDot,
  faPencil,
  faPhone,
  fasPhoneArrowDownLeft,
  fasBuilding,
  falPhoneArrowDownLeft,
  faPlus,
  faRocket,
  faScrewdriverWrench,
  faSpinnerThird,
  faStore,
  faShop,
  faTimer,
  faTrashCan,
  faUser,
  faUsers,
  faXmark,
  faCoins,
  faPercent,
  fasPhone,
  faSolidPercent,
  faFilePdf,
  faFileExcel,
  faCircleSmall,
  faCircleInfo,
  fadGrid2,
  fasGrid2,
  falGrid2,
  faSpinner,
  faExclamation,
  faCalendar,
  faBars,
  faArrowRight,
  faFileExcel,
  faFile,
  faUpload,
  faMagnifyingGlass,
  faDownload,
  faObjectsColumn,
  faDiagramCells,
  faFlag,
  faMugHot,
  faMugTea,
  faCupTogo,
  faWhiskeyGlass,
  faArrowLeft,
  faImageSlash,
  faForward,
  faBell,
  faStar,
  faIslandTropical,
  faCompass,
  faTrowelBricks,
  faFileArrowDown,
  falHouse,
  faChartMixed,
  fasFile,
  falAddressCard,
  fasFilePdf,
  fasMagnifyingGlass,
  faHandHoldingDollar,
  faInfinity,
  fadStar,
  faStarHalf,
  fadSpinnerThird,
  falHouse,
  falBell,
  falUser,
  faGauge,
  fasHouse,
  fasBell,
  fasUser,
  fasGauge,
  faHourglass,
  faScaleUnbalanced,
  faCalendars,
  faHouseCircleExclamation,
  fasFileCheck,
  falFileCheck,
  faRotateLeft,
  faBriefcase,
  faHouseCircleCheck,
  faSack,
  fasHouseCircleCheck,
  falHouseCircleCheck,
  faChartMixed,
  fasFile,
  falAddressCard,
  fasFilePdf,
  fasMagnifyingGlass,
  faHandHoldingDollar,
  faLoader,
  faCircleCheck,
  faCircleXmark,
  faEnvelopes,
  faPaperclip,
  faCamera,
  faCameraRotate,
  faCircleQuarter,
  faHandshake,
  faUserTie,
  faClockRotateLeft,
  faFiles,
  faCalendarDays,
  faFileCircleInfo,
  faSpinner,
  faSack,
  faArrowUp,
  faArrowDown,
  faArrowUpArrowDown,
  faHashtag,
  fadArrowLeft,
  faShopSlash,
  faUserGroupCrown,
  falUserGroupCrown,
  faInfo,
  faTriangle,
  faMessageSlash,
  faBadgeCheck,
  fadCircleXmark,
  fasSpinner,
  fasBuildings,
  fadListRadio,
  fadAddressBook,
  fadFileLines,
  faFileCirclePlus,
  fasEye,
  faRabbitRunning,
  faShieldCheck,
  fasEnvelope,
  faShareAll,
  faMobileNotch,
  faRectangleHistoryCircleUser,
  fasBadgeCheck,
  faRefresh,
  fasTrashCan,
  falPlay,
  faComments,
  faIdCard,
  faListTree,
  faComment,
  faPenFancy,
  fadXmark,
  faFaceViewfinder,
  faCopy,
  faBadgePercent,
  faReceipt,
  faCirclePlay,
  fasPencil,
  faGavel,
  fasGavel,
  faTrash,
  fasListTree,
  fasPenFancy,
  fasListCheck,
  fasHouseBuilding,
  fasUsers,
  fasIdCard,
  fasCoins,
  fasPercent,
  faPercentage,
  falPercentage,
  faCalendarWeek,
  faGear,
  falGear,
  falFaceViewfinder,
  faDeleteLeft,
  falXmark,
  fadCheck,
  fadEuroSign,
  faWallet,
  falEuroSign,
  fasEuroSign,
  faFingerprint,
  fasFiles,
  fasChartMixed,
  fasChartLineUp,
  fasHandHoldingDollar,
  fasDisplayChartUp,
  falFiles,
  falChartMixed,
  falChartLineUp,
  falHandHoldingDollar,
  falDisplayChartUp,
  falCog,
  faArrowUpFromSquare,
];
